//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum TargetDeleteMode {
	Delete = 0,
	CrossDelete = 1,
	None = 2
}
